import React from 'react';
import { useUserSettings } from '../../context/CurrentUserContext';
import ListaSociedadesContainer from '../../components/Listas/SociedadesSeleccion';
import ConfiguracionColumnasUsuarioContainer from './VisorColumnas/view';
import ConfiguracionMisDatosUsuarioContainer from './MisDatos/view';

const ContainerSociedades: React.FC<any> = () => {
    let {currentUser} = useUserSettings();

    return (
        <ListaSociedadesContainer user={currentUser} actions/>
    )
}

const ContainerColumnas: React.FC<any> = () => {
    let {currentUser} = useUserSettings();

    return (
        <ConfiguracionColumnasUsuarioContainer user={currentUser}/>
    )
}

const ContainerDatos: React.FC<any> = () => {
    let {currentUser,setCurrentUser} = useUserSettings();

    return (
        <ConfiguracionMisDatosUsuarioContainer user={currentUser} setUser={setCurrentUser}/>
    )
}

export const TiposConfiguracion = {
    SOCIEDADES:{
        titulo: 'CONFIGURACIÓN DE SOCIEDADES (PARTES)',
        container: <ContainerSociedades/>
    },
    COLUMNAS:{
        titulo: 'CONFIGURACIÓN DE COLUMNAS',
        container: <ContainerColumnas/>
    },
    DATOS:{
        titulo: 'MIS DATOS',
        container: <ContainerDatos/>
    }
}

export interface ConfiguracionUsuario{
    tipo: typeof TiposConfiguracion
}